module.exports = __webpack_public_path__ + "static/media/des6.85ef5f23.jpg";